import React from 'react';
import { FaSearch, FaGamepad, FaRocket, FaChartBar } from 'react-icons/fa';
import SectionHeader from '../ui/SectionHeader';
import TiltCard from '../ui/TiltCard';
import services from '../../data/services.json';
import './Services.css';

const ICONS = {
  FaSearch: FaSearch,
  FaGamepad: FaGamepad,
  FaRocket: FaRocket,
  FaChartBar: FaChartBar,
};

const Services = () => {
  return (
    <section className="services tra-section" id="services">
      <div className="tra-container">
        <SectionHeader
          eyebrow="What We Do"
          title="End-to-end marketing built for gaming"
          subtitle="From talent to analytics, we run the full campaign so you can focus on the game."
        />

        <div className="services__grid">
          {services.map((svc, i) => {
            const Icon = ICONS[svc.icon] || FaGamepad;
            return (
              <TiltCard className="service-card" key={svc.id} delay={i * 0.08}>
                <div className="service-card__icon">
                  <Icon size={22} />
                </div>
                <h3 className="service-card__title">{svc.title}</h3>
                <span className="service-card__subtitle">{svc.subtitle}</span>
                <p className="service-card__desc">{svc.description}</p>

                {svc.stats && (
                  <div className="service-card__stats">
                    {svc.stats.map((s) => (
                      <div className="service-card__stat" key={s.label}>
                        <span className="service-card__stat-value">{s.value}</span>
                        <span className="service-card__stat-label">{s.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </TiltCard>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
